import { actions, ITableFilterRecordType } from "@/redux/reducers/TableFilter";
import { RootState } from "@/redux/store";
import { GridFilterModel } from "@mui/x-data-grid-pro";
import { useDispatch, useSelector } from "react-redux";

interface IUseFilterStateStoreArgs extends Partial<Omit<ITableFilterRecordType, "filterModel">> {
	initialFilterModel?: GridFilterModel;
}

export const useFilterStateStore = (args: IUseFilterStateStoreArgs) => {
	const { key = "", persistAcrossLocations = false, persistAcrossRouteChange = false, initialFilterModel } = args;

	const storedFilterModel = useSelector((state: RootState) => state.tableFilter[key ?? ""]?.filterModel);

	const dispatch = useDispatch();

	return {
		filterModel: storedFilterModel ?? initialFilterModel,
		updateFilterStore: (filterModel: GridFilterModel) => {
			if (!key) {
				return;
			}
			dispatch(actions.UPDATE_FILTER({ key, filterModel, persistAcrossLocations, persistAcrossRouteChange }));
		},
	};
};
